import {delay} from '@yandex-delivery/utils'

import type {AppConfig} from '../../../types'
import type {SharingRequest, SharingResponse} from '../repo/types'
import {toPaymentInfo} from './mappers/toPaymentInfo'
import type {OrderService, OrderServiceParams} from './types'

const DELAY_TIMEOUT_MS = 1000

export function createOrderService(params: OrderServiceParams): OrderService {
  const {dcaaRepository} = params
  const {fetchPaymentMethods, fetchForm, fetchAcceptOfferBase, fetchSharingBase} = dcaaRepository

  async function fetchPollSharing(
    appConfig: AppConfig,
    body: SharingRequest,
    retriesOnNetworkErrors: number = 0,
  ): Promise<SharingResponse> {
    return fetchSharingBase(appConfig, body)
      .then(response => {
        return response.body.sharing_key
          ? response
          : delay(DELAY_TIMEOUT_MS).then(() => fetchPollSharing(appConfig, body, retriesOnNetworkErrors))
      })
      .catch(error => {
        if (retriesOnNetworkErrors > 0) {
          return fetchPollSharing(appConfig, body, retriesOnNetworkErrors - 1)
        }

        return Promise.reject(error)
      })
  }

  async function fetchPaymentInfo(appConfig: AppConfig) {
    return fetchPaymentMethods(
      appConfig,
      {
        should_return_only_selected: true,
        mode: 'employee',
      },
      appConfig.countryCode,
    ).then(toPaymentInfo)
  }

  return {
    fetchPaymentInfo,
    fetchPollSharing,
    async fetchFormLayout(appConfig, body) {
      return fetchForm(appConfig, body).then(response => response.body.descriptors)
    },
    async fetchAcceptOffer(appConfig, body) {
      return fetchAcceptOfferBase(appConfig, body).then(res => res.body)
    },
  }
}
